import styled from 'styled-components';

export const StyledProductCardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  margin-top: 0.5rem;
  overflow-x: auto;
  padding-bottom: 0.25rem;
`;

export const StyledProductCard = styled.div`
  flex: 0 0 auto;
  width: 99%;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--card-border-color);
  background: var(--card-bg-color);
  border-radius: 0.75rem;
  overflow: hidden;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  padding: 0.875rem 0.875rem 0rem;
  gap: 0.875rem;
`;

export const StyledInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  gap: 0.25rem;
`;

export const StyledTitle = styled.div`
  font-size: 0.875rem;
  font-weight: 700;
  color: rgb(26, 28, 30);
  line-height: 1.3;
  text-wrap: pretty;
  word-break: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const StyledPartNumber = styled.div`
  font-size: 0.719rem;
  color: rgb(138, 144, 153);
  font-weight: 500;
`;

export const StyledPrice = styled.div`
  font-size: 1.063rem;
  font-weight: 800;
  color: rgb(17, 17, 17);
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
`;

export const StyledImageWrapper = styled.div`
  flex: 0 0 5.125rem;
  width: 5.125rem;
  height: 5.125rem;
  border-radius: 0.75rem;
`;

export const StyledProductCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 0.75rem;
  background: var(--card-bg-color);
`;

export const StyledImagePlaceholder = styled.div<{ $primary?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 0.75rem;
  color: ${({ $primary }) => $primary};
  background: ${({ $primary }) => `color-mix(in srgb, ${$primary} 9%, transparent)`};
  border: 1px solid ${({ $primary }) => `color-mix(in srgb, ${$primary} 18%, transparent)`};

  svg {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

export const StyledProductCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.5rem 0.875rem 0;
`;

export const StyledProductCardDescription = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-size: 0.781rem;
  color: rgb(95, 102, 114);
  line-height: 1.5;
  text-wrap: pretty;

  // Paragraphs are flattened to inline so -webkit-line-clamp can clamp across
  // them as one continuous text flow — multiple block-level children clamp
  // unreliably across browsers.
  p {
    margin: 0;
    display: inline;
  }

  p + p::before {
    content: " ";
  }

  a {
    color: var(--main-color);
  }
`;

export const StyledProductCardLink = styled.a`
  font-size: 0.688rem;
  font-weight: 600;
  color: var(--main-color);
  text-decoration: underline;
  white-space: nowrap;
  padding: 0.75rem 0;
`;

export const StyledButton = styled.button<{ $primary?: string }>`
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  background: ${({ $primary }) => $primary};
  color: rgb(255, 255, 255);
  border-width: medium;
  border-style: none;
  border-color: currentcolor;
  border-image: initial;
  border-radius: 10px;
  padding: 11px 16px;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
`;
